import { CSSProperties } from '@mantine/core';
import { IconProps } from '@tabler/icons-react';
import { ElementType } from 'react';

import { brand } from '../theme';

export type IIconProps = IconProps & {
  icon: ElementType;
  style?: CSSProperties;
};

export function ZorroIcon({
  icon: Icon,
  color = brand.zorroCoal900,
  size = 24,
  stroke = 1.5,
  ...props
}: IIconProps) {
  return <Icon color={color} size={size} stroke={stroke} {...props} />;
}
